export default __webpack_public_path__ + "static/media/dropdown-active.af9889fc.svg";